/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Gear(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256.00098 256.00098"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={128.00098}
        cy={128}
        r={48}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M183.66185,65.08649a84.52221,84.52221,0,0,1,7.25219,7.2521l27.32235,3.90156a103.36936,103.36936,0,0,1,10.1637,24.56086L211.84563,122.8728s.20824,6.83942.00065,10.2547l16.561,22.07863a103.37014,103.37014,0,0,1-10.18033,24.554l-27.31288,3.90133s-4.689,4.98345-7.25071,7.25163l-3.90155,27.32234a103.36988,103.36988,0,0,1-24.56087,10.16371l-22.07039-16.55388a84.521,84.521,0,0,1-10.25609.00006l-22.07863,16.561a103.369,103.369,0,0,1-24.554-10.18033l-3.90077-27.31148a84.52089,84.52089,0,0,1-7.25219-7.25211l-27.32235-3.90155A103.36926,103.36926,0,0,1,27.60284,155.2L44.1573,133.12818s-.20824-6.83942-.00065-10.2547l-16.561-22.07863A103.37,103.37,0,0,1,37.776,76.24087l27.31149-3.90076a84.52089,84.52089,0,0,1,7.2521-7.2522l3.90155-27.32235A103.37026,103.37026,0,0,1,100.802,27.60186l22.07039,16.55388a84.523,84.523,0,0,1,10.25609-.00007l22.07863-16.561a103.36979,103.36979,0,0,1,24.554,10.18033Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
    </Svg>
  );
}

export default Gear;
